import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import LoadingScreen from '@/components/loading-screen';
import { useImpersonation } from '@/contexts/ImpersonationContext';
import useAccessibleAccounts from '@/hooks/useAccessibleAccounts';
import { switchToOwnProfile } from '@/layouts/dashboard/nav/AccountSwitcher/switchAccountAndBusiness';

// Dentro da conta de outra pessoa o perfil mostraria e alteraria o cadastro do titular, e por
// isso fica fechado (CKTPL-1726). Com o seletor de conta e negócio, quem chega aqui por link ou
// pela URL volta para a própria conta e o perfil abre ali, como no menu de perfil (CBK-681).
export default function ProfileAccountGuard({ children }) {
  const { impersonatedUserId } = useImpersonation();
  const { accounts, isAvailable, isLoading } = useAccessibleAccounts();
  const shouldSwitch = Boolean(impersonatedUserId) && !isLoading && isAvailable;

  useEffect(() => {
    if (shouldSwitch) {
      switchToOwnProfile(accounts);
    }
  }, [shouldSwitch, accounts]);

  if (!impersonatedUserId) {
    return children;
  }

  if (isLoading || shouldSwitch) {
    return <LoadingScreen />;
  }

  return <Navigate to="/403" replace />;
}

ProfileAccountGuard.propTypes = {
  children: PropTypes.node,
};
